import { useState } from 'react';
import { resolveProductImageUrl } from '../utils/product';

interface ProductGalleryProps {
  images: string[];
  alt: string;
}

export default function ProductGallery({ images, alt }: ProductGalleryProps) {
  const [activeIndex, setActiveIndex] = useState(0);
  const safeImages = (images.length > 0 ? images : ['']).map(resolveProductImageUrl);
  const activeImage = safeImages[activeIndex] ?? safeImages[0];

  return (
    <div className="product-gallery">
      <div className="product-gallery-main">
        <img src={activeImage} alt={alt} />
      </div>

      {safeImages.length > 1 && (
        <div className="product-gallery-thumbs">
          {safeImages.map((src, index) => (
            <button
              key={`${src}-${index}`}
              type="button"
              className={`gallery-thumb ${index === activeIndex ? 'active' : ''}`}
              onClick={() => setActiveIndex(index)}
              aria-label={`Görsel ${index + 1}`}
            >
              <img src={src} alt="" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
